import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { ShellDomainProvider } from '../utility/shell-domain.provider';

@Injectable()
export class EcapCoreUserAccessManagementService {

    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(private http: HttpClient) {
    }

    getUserList(payload): any {
        return this.http.post(ShellDomainProvider['api'].Security + 'SecurityQuery/GetUsers', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    getRoles(payload): any {
        return this.http.post(ShellDomainProvider['api'].Security + 'SecurityQuery/GetRoles', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    RoleExists(roleName) {
        return this.http.get(ShellDomainProvider['api'].Security + 'SecurityQuery/GetUserById?RoleName=' + roleName,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    CreateRole(roleName): any {
        return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/CreateRole', { "RoleName": roleName },
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    ResendActivationEmail(userId): any {
        return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/ResendActivationEmail', { "UserId": userId },
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    GetUserById(userId): any {
        return this.http.get(ShellDomainProvider['api'].Security + 'SecurityQuery/GetUserById?UserId=' + userId,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    UpdateUser(payload): any {
        return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/UpdateUser', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    CreateUser(payload): any {
        return this.http.post(ShellDomainProvider['api'].Security + 'SecurityCommand/CreateUser', payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    IsEmailAvaiable(email): any {
        return this.http.post(
            ShellDomainProvider['api'].Security + "Authentication/IsEmailAvaiable",
            { Email: email },
            { headers: this.header, withCredentials: true, observe: 'response' }
        );
    }

    CheckRecoverCodeAndPhomeNumberValidity(activationCode) {
        return this.http.get(ShellDomainProvider['api'].Security + 'Authentication/ActivateAccountCodeCheck?ActivateAccountCode=' + activationCode,
        { headers: this.header, withCredentials: true, observe: 'response' });
    }

    ActivateAccount(payload) {
        return this.http.post(
            ShellDomainProvider['api'].Security + "Authentication/ActivateAccount",
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' }
        );
    }

}
